// Util引入
import st_util from "@/components/st_comps/st_comp/utils/util"
import td_util from "@/components/st_comps/td_comp/util"
import local_util from "@/components//local_comps/util"

export default Object.assign(
    st_util, 
    td_util, // 存在命名冲突的可能性，建议产品级别及页面级别的函数名使用相应前缀
    local_util
)